//* Import necessary modules
import React from "react";

//* Import components from Bootstrap
import { Form, FormControl as Input, InputGroup } from "react-bootstrap";

//! Import components
import { Attention } from "../../../component/base/Attention";


//? Define the props interface
type QuantityFieldProps = {
  label: string;
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}

/**
 * A memoized functional component that renders a quantity input field with a label.
 * 
 * @param {Object} props - The properties object.
 * @param {string} props.label - The label for the input field.
 * @param {number} props.value - The current value of the input field.
 * @param {Function} props.setValue - The function to update the value of the input field.
 * 
 * @returns {JSX.Element} The rendered quantity input field component.
 */
export const QuantityField = React.memo(
  ({ label, value, setValue }: QuantityFieldProps) => (
    <InputGroup className="mb-3">
      <div className="flex fdcolumn flex1">
        <Form.Label>
          {label} <Attention />
        </Form.Label>
        <Input
          type="number"
          placeholder={`Digite a quantidade de ${label.toLowerCase()}`}
          value={value}
          onChange={(e) => setValue(Math.max(0, Number(e.target.value) || 0))}
          required
          min={0}
        />
      </div>
    </InputGroup>
  )
);
